import { enhanceReportRows } from '../../../hooks/data/useAddFulfillmentColumns.js';
import ButtonController from "../../../components/containers/buttonController";
import DownloadButton from "../../../components/common/button/DownloadButton";
import { reportConfig } from "../../../utils/config/tableReportConfig.js";
import DynamicTable from "../../../components/tables/dynamicTable";
import { getFilteredReport } from "../../../utils/api/reportData";
import { getDynamicSelectData } from "../../../utils/api/data";
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from "../../../components/sidebar/Sidebar";
import NavBar from "../../../components/navbar/NavBar";
import React, { useEffect, useState } from "react";
import { useSelector,  } from "react-redux";
import Cookies from "js-cookie";
import "./FlexHub.css";

//OquirhHills is the other COC that we are adding


const FlexHubReport = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const reportFilters = useSelector((state) => state.report.reportFilter);
    const cpName = Cookies.get("cp-cn");

    useEffect(() => {
        const hasActiveFilters = reportFilters.some(
          (filter) =>
            filter.field !== "" && filter.operator !== "" && filter.value !== ""
        );
        if (hasActiveFilters) {filterReport();}
        else {
         if (cpName === 'FlexHub') {getReportDataMaster();}
         else {getReportDataCOC(cpName)}
        }
    }, [reportFilters]);

    const filterReport = async () => {
      setLoading(true);
      const filteredData = await getFilteredReport("flexhub", Cookies.get("cp-cn"), reportFilters );
      if (cpName === "FlexHub") {
        setReportData(filteredData);
      } else {
        const enhancedResponse = await enhanceReportRows(filteredData);
        setReportData(enhancedResponse);
      }
      setLoading(false);
    };

    const getReportDataMaster = async () => {
      setLoading(true);
      const response = await getDynamicSelectData({
        selectValues: `${reportConfig["flexhubAdmin"].selectValues}, (COST * 1.1) AS COC_COST`,
        tableName: "REPORT.FLEXHUB_CUSTOMERPORTAL_VIEW",
        whereField: ["SHIPDATE"],
        whereOperators: [">"],
        whereValue: ['1900-01-01'],
        orderBy: "SHIP_DATE DESC NULLS LAST",
        db: "SF",
      });
      setReportData(response);
      setLoading(false);
    };

    const getReportDataCOC = async (cpName) => {
      setLoading(true);
      const response = await getDynamicSelectData({
        selectValues: `${reportConfig["flexhubCOC"].selectValues}`,
        tableName: "REPORT.FLEXHUB_CUSTOMERPORTAL_VIEW",
        whereField: ["CUSTOMERNAME"],
        whereOperators: ["="],
        whereValue: [cpName],
        orderBy: "SHIP_DATE DESC NULLS LAST",
        db: "SF",
      });
        const enhancedResponse = await enhanceReportRows(response);
        setReportData(enhancedResponse);
        setLoading(false);
    };

    useEffect(() => {
      if (cpName === "FlexHub") {getReportDataMaster();} 
      else {getReportDataCOC(cpName);}
    }, []);

  return (
    <div className="laneviewTrendsPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="laneviewTrendsPageContent">
          <div className="laneviewTrendsTop">
            <div className="fulfillmentTitle">
              <h1>{cpName} Report</h1>
            </div>
          </div>
          <div className="laneviewTrendsMid">
            <div className="lvtreportSpace">
                <div className='reportTable'>
                {loading ? (
                  <CircularProgress style={{ margin: 'auto', display: 'block' }} />
                ) : (
                  <DynamicTable dataObject={{ data: reportData, size: "small" }} />
                )}
                </div>
                <div className="reportButtons">
                <div>
                  <DownloadButton data={reportData} fileName={"flexhub_report"}/>
                </div>
                <div>
                  <ButtonController reportName={cpName === 'FlexHub' ? 'FlexHub Report' : 'FlexHub Report'} />
                </div>
              </div>
            </div>
          </div>
          <div className="laneviewTrendsBottom"></div>
        </div>
      </div>
    </div>
  );
};

export default FlexHubReport;
